var login_ajax = (function( $ ) {

	var loading = function( $elem ) {
		$elem.find( '.ajax-loader' ).fadeIn();
	};

	var loaded = function( $elem ) {
		$elem.find( '.ajax-loader' ).fadeOut();
	};

	var login = function( $form, callback, redirect ) {
		var data = {
			'action'   : 'crate_login_action',
			'username' : $form.find( 'input[name=username]' ).val(),
			'password' : $form.find( 'input[name=password]' ).val(),
			'nonce'    : ScriptData.crate_login_action_nonce,
			'redirect' : typeof redirect === 'undefined' ? '' : redirect
		};

		$.post( ScriptData.ajaxurl, data, function( response ) {
			if ( response.can_view.content ) {
				$.cookie( 'bust_cache', 'true', { expires: 1, path: '/' } );
			} else {
				$.removeCookie( 'bust_cache', { path: '/' } );
			}

			callback(response);
		} );
	};

	return {
		login: login,
		loading: loading,
		loaded: loaded
	};

})( jQuery );

module.exports = login_ajax;